module.exports = __webpack_public_path__ + "static/Danzza-Bold-1b404e6dabdc30953f6ecafece2b01af.woff2";